export const COMPLIANCE_ACCORDION_ITEMS = {
  meetingDeletion: 'meeting-deletion',
  meetingTrimming: 'meeting-trimming',
  trackingConsent: 'tracking-consent',
  complianceNotice: 'compliance-notice',
  processEmailContent: 'process-email-content',
  confirmationNotice: 'confirmation-notice',
  auditLog: 'audit-log',
  complianceMessage: 'compliance-message',
} as const
